export default {"src":"/komodo/_next/static/media/the_fintech_times.d98a0e25.svg","height":78,"width":674,"blurWidth":0,"blurHeight":0};